import React from 'react';
import { useDistribution } from '../../../../hooks';
import { ImageHandler } from '../../../../components';
import { Container, LeftSide, RightSide } from './styles';

const Header: React.FC = () => {
    const { exhibitor, voucherType, availableAmount } = useDistribution();

    return exhibitor && voucherType ? (
        <Container >
            <LeftSide>
                <ImageHandler
                    url={exhibitor.logo}
                    alt={exhibitor.name}
                />
                <div>
                    <span>{exhibitor.name}</span>
                    <small>{voucherType.name}</small>
                </div>
            </LeftSide>
            <RightSide >
                <small>
                    cortesias
                    <br />
                    disponíveis
                </small>
                <span>{availableAmount}</span>
            </RightSide>
        </Container>
    ) : (
        <></>
    );
};

export { Header };
